import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import Close from 'aquilla/icons/actions/Close';

const Wrapper = styled.div`
  width: 100%;
`;

const CloseImgWrapper = styled.div`
  width: ${Spacings.SPACING_8B};
  height: ${Spacings.SPACING_8B};
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 146px;
  height: ${Spacings.SPACING_30B};
  margin-top: ${Spacings.SPACING_4B};
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 0 auto;
  }
`;

const HeadingWrapper = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.H4};
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_26};
  margin-top: ${Spacings.SPACING_6B};
`;

const HR = styled.hr`
  background-color: var(--color-i-green-99);
  height: ${Spacings.SPACING_1};
  border: none;
  margin-top: ${Spacings.SPACING_6B};
  max-width: 98%;
`;

const OfferingWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-top: ${Spacings.SPACING_6B};
  img {
    padding-top: ${Spacings.SPACING_2} !important;
  }
`;

const OfferingText = styled(P1)`
  color: var(--color-i-black);
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.LIGHT};
  padding-left: ${Spacings.SPACING_2B};
  line-height: ${Spacings.SPACING_5B};
  max-width: 95%;
`;

const DialogEnquiryStaticInfo = ({ closeDialogHandler }) => {
  const offerings = [
    'Learn face-to-face from the best educators in your city',
    'Access high-tech library, spacious classrooms, cafe and more',
    'Regular educator-parent connect'
  ];
  return (
    <Wrapper>
      <CloseImgWrapper onClick={closeDialogHandler}>
        <Close />
      </CloseImgWrapper>
      <ImageWrapper>
        <Image
          src="allCentre/DialogEnquiryFormImage.svg"
          alt="all-centre-enquiry-form"
          layout="fill"
        />
      </ImageWrapper>
      <HeadingWrapper>
        Book a call with us for any query regarding centres
      </HeadingWrapper>
      <HR />
      {offerings?.map((offering, index) => (
        <OfferingWrapper key={String(index)}>
          <Image
            src="allCentre/AllCentreOffering.svg"
            width={18}
            height={18}
            alt="all-centre-offering"
          />
          <OfferingText>{offering}</OfferingText>
        </OfferingWrapper>
      ))}
    </Wrapper>
  );
};

export default DialogEnquiryStaticInfo;
